<div class="file-upload d-flex align-items-center" [ngClass]="variant" fxLayout="row" fxLayoutAlign="start center">
  <div>
    <label for="file-input" class="custom-file-upload" [style]="imageUrl ? 'border: none;' : ''" (click)="onOpenFile(); $event.preventDefault()">
      <img
        *ngIf="!imageUrl && variant !== 'business-logo'"
        src="/assets/img/upload_img.svg"
        alt=""
        title="Upload"
        class="default-img"
      />
      <ng-container *ngIf="!imageUrl && variant === 'business-logo'">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M2.5 18.5L6.77044 14.2296C7.55197 13.448 7.94273 13.0573 8.39428 12.9083C8.79155 12.7773 9.21991 12.7741 9.61907 12.8993C10.0728 13.0415 10.4693 13.4265 11.2623 14.1964L14.4861 17.3264M21.5 17.6875L20.0752 16.2627C19.2832 15.4707 18.8872 15.0747 18.4305 14.9263C18.0289 14.7958 17.5962 14.7958 17.1945 14.9263C16.7378 15.0747 16.3416 15.4709 15.5493 16.2633C14.9448 16.8677 14.4861 17.3264 14.4861 17.3264M18.5 21.3403L14.4861 17.3264M18 9V6M18 6V3M18 6H15M18 6H21M12 2H11.5C8.234 2 6.601 2 5.34627 2.61876C4.16167 3.20294 3.20294 4.16167 2.61876 5.34627C2 6.601 2 8.234 2 11.5V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.5C15.766 22 17.399 22 18.6537 21.3812C19.8383 20.7971 20.7971 19.8383 21.3812 18.6537C22 17.399 22 15.766 22 12.5V12" stroke="#635CA8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </ng-container>
      <img [src]="imageUrl" alt="Uploaded Image" *ngIf="imageUrl" class="preview-img" />
    </label>
    <button
      *ngIf="imageUrl"
      type="button"
      class="clear-image-btn"
      (click)="clearFile($event)"
      aria-label="Clear uploaded image"
    >
      ×
    </button>
    <input
      id="file-input"
      type="file"
      accept="image/*"
      (change)="onFileSelected($event)"
      #fileInput
    />
  </div>
  <main class="upload-text-block" fxLayout="column" fxLayoutAlign="center start" fxFlex="1 1 auto">
    <p class="label flex items-start">{{ "Business_Logo" | translate }} <span *ngIf="isRequired" class="text-danger ms-2">*</span></p>
    <span class="description" [attr.data-translate-key]="variant === 'business-logo' ? 'Business_Logo_Photo_Size' : 'max_size'">
      {{ (variant === 'business-logo' ? 'Business_Logo_Photo_Size' : 'max_size') | translate }}
    </span>
    <!-- <a *ngIf="variant === 'default'" class="link" (click)="onOpenFile(); $event.preventDefault()">{{
      "Click_to_upload_logo" | translate
    }}</a> -->
  </main>
</div>
